export default __webpack_public_path__ + "pgnv-assets/054db10408d67fe0a8583ba5fdb3337f.png";